module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sendPoints"
  }, [_c('img', {
    attrs: {
      "src": require("./tittle.png"),
      "width": "100%",
      "alt": ""
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "form",
      "method": "post",
      "onsubmit": "return false",
      "action": "##"
    }
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.selectHandle('1')
      }
    }
  }, [(_vm.select) ? _c('img', {
    staticClass: "icon-select",
    attrs: {
      "src": require("./icon1.png"),
      "width": "15px",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.select) ? _c('img', {
    staticClass: "icon-select",
    attrs: {
      "src": require("./icon2.png"),
      "width": "15px",
      "alt": ""
    }
  }) : _vm._e(), _vm._v("\n        东航期货账户参赛\n      ")]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.selectHandle('2')
      }
    }
  }, [(!_vm.select) ? _c('img', {
    staticClass: "icon-select",
    attrs: {
      "src": require("./icon1.png"),
      "width": "15px",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.select) ? _c('img', {
    staticClass: "icon-select",
    attrs: {
      "src": require("./icon2.png"),
      "width": "15px",
      "alt": ""
    }
  }) : _vm._e(), _vm._v("\n        其他期货公司账户参赛\n      ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.inviteeMobile),
      expression: "formData.inviteeMobile"
    }],
    staticClass: "clientMobile",
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formData.inviteeMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.inviteeMobile = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.code),
      expression: "formData.code"
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.formData.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send",
    class: {
      disable: this.verifyMsg !== '获取验证码'
    },
    on: {
      "click": function($event) {
        _vm.sendCode()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.verifyMsg) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("参赛后将自动为您注册该手机号，以便后续发放积分")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tips1"
  }, [_vm._v("\n    从事证券投资或期货交易，请通过合法证券期货经营机构进行。合法机构名单可到中国证监会网站(www.csrc.gov.cn)查询。\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "tips2"
  }, [_vm._v("—— 交易有风险 入市需谨慎 ——")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "submit-button"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("立即申请")])]), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule"
  }, [_c('div', {
    staticClass: "rule-title"
  }, [_vm._v("参与规则")]), _vm._v(" "), _c('div', {
    staticClass: "title-box way1"
  }, [_vm._v("方式一：首次成为东航期货客户")]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('div', [_vm._v("立即开户成为东航期货客户并报名参赛。")]), _vm._v(" "), _c('div', [_vm._v("参赛后，初始本金大于1000元且至少有一笔交易，则视为成功参与。")]), _vm._v(" "), _c('div', [_vm._v("双方可获得2000积分奖励！")])]), _vm._v(" "), _c('div', {
    staticClass: "title-box way2"
  }, [_vm._v("方式二：已有其他期货公司账户")]), _vm._v(" "), _c('div', {
    staticClass: "content content2"
  }, [_c('div', [_vm._v("直接报名参赛。")]), _vm._v(" "), _c('div', [_vm._v("参赛后，初始本金大于1000元且至少有一笔交易，则视为成功参与。")]), _vm._v(" "), _c('div', [_vm._v("双方可获得200积分奖励！")]), _vm._v(" "), _c('p', [_vm._v("\n        所有奖励积分将在下个交易日自动发放至邀请人手机号及报名参赛手机号。\n      ")]), _vm._v(" "), _c('p', [_vm._v("您可通过东航期货APP登录兑换。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rule introduce"
  }, [_c('div', {
    staticClass: "rule-title introduce-rule"
  }, [_vm._v("大赛简介")]), _vm._v(" "), _c('div', {
    staticClass: "introduce-box introduce-box1"
  }, [_c('img', {
    attrs: {
      "src": require("./pic1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        “蓝海密剑”对冲基金经理公开赛，是由东航期货公司主办的模拟军事化系列品牌期货实盘赛事。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce-box introduce-box2"
  }, [_c('img', {
    attrs: {
      "src": require("./pic2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        大赛的赛制完善，且具有长周期赛制、多指标账户系统评估业绩、专业增值产品服务、奖金丰富等特色。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "introduce-box introduce-box3"
  }, [_c('img', {
    attrs: {
      "src": require("./pic3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n        大赛每年的奖金超过100万元，专设年度先锋勋章、晋衔奖、高地军旗手等奖项，于每届比赛结束后颁发。\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f673269c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/sendPoints/submit.vue
// module id = 916
// module chunks = 2